import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

export default [
  set(state`node.panel.tags.${props`index`}.selected`, props`value`)
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/toggleGroup.js